import { Stack } from 'component-library';
import { Trans, useTranslation } from 'react-i18next';

import { EcosystemType } from '@/api/rest/resources/types/fact';
import { METHODOLOGY_EXPLAINER_PAGE_EII } from '@/config/constants';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const EiiExplainer = ({ eiiType = EcosystemType.terrestrial }: { eiiType: EcosystemType }) => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='eii-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t(`shared.ncaDetail.details.ecosystemIntegrityIndex.explainers.howDoMeasureThis.${eiiType}.headline`)}
        </ExplainerTitle>
        <Stack className='items-start pb-6'>
          <ExplainerBody>
            <ExplainerCopy
              body={
                <Trans
                  i18nKey={`shared.ncaDetail.details.ecosystemIntegrityIndex.explainers.howDoMeasureThis.${eiiType}.body`}
                  components={{
                    p: <p className='mb-3 last:mb-0' />,
                    ul: <ul className='mb-3 list-disc pl-5' />,
                    li: <li />,
                  }}
                />
              }
            />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_EII} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
